var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mp-sections"},[_c(_setup.MyProjectsWatchlist,{staticClass:"bcx-all bcx-main-content mp-content-area-padding",attrs:{"type":"made"}}),_c(_setup.MyProjectsWatchlist,{staticClass:"bcx-all bcx-main-content mp-content-area-padding",attrs:{"type":"watched"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }